// src/components/partials/MappedInWizard/steps/Step0Intro.tsx

type Props = {
  onNext: () => void
}

export default function Step0Intro({ onNext }: Props) {
  return (
    <div style={{ maxWidth: '700px', margin: '0 auto' }}>
      <h2>Welcome to the MappedIn Integration Wizard</h2>

      <p style={{ fontSize: '1rem', lineHeight: 1.6 }}>
        This guided setup will help you connect your <strong>Mappedin</strong> venue data to your
        <strong> React Mobile</strong> environment. Youll go through the following steps:
      </p>

      <ol style={{ paddingLeft: '1.5rem', fontSize: '1rem', lineHeight: 1.8 }}>
        <li>🔐 Authenticate using your Mappedin API key and secret</li>
        <li>🏢 Match your Mappedin floors to React Mobile floors</li>
        <li>🚪 Match your Mappedin spaces (rooms) to React Mobile rooms</li>
        <li>📍 Link POIs from Mappedin to beacons in React Mobile</li>
      </ol>

      <p>
        If you need help finding your API keys, please visit your Mappedin dashboard or contact your system admin. you
        will go through the following steps:
      </p>

      <button
        onClick={onNext}
        style={{
          marginTop: '2rem',
          padding: '0.75rem 1.5rem',
          backgroundColor: '#29a096',
          color: 'white',
          fontWeight: 'bold',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Get Started
      </button>
    </div>
  )
}
